// we want to keep them mutable so can't use 'as const', but at the same time we need correct types to match
// enum from db, which can't be imported here, until prisma switches to esm see new generator prisma-client (without -js)
const literalArray = (...args) => args;
export const CvManagerNotificationSettings = literalArray('cv_employer_signed_up', 'cv_verifier_signed_up', 'cv_employee_sent_my_verify', 'cv_data_dispute_initiated', 'cv_report_created_status', 'cv_employer_invited', 'cv_verifier_invited', 'cv_new_get_help_request', 'cv_new_data_delete_request', 'cv_inbox_item_commented');
export const CvAdminNotificationSettings = literalArray('cv_employer_signed_up', 'cv_verifier_signed_up', 'cv_employee_sent_my_verify', 'cv_data_dispute_initiated', 'cv_report_created_status', 'cv_employer_invited', 'cv_verifier_invited', 'cv_payment_received', 'cv_payment_declined', 'cv_new_get_help_request', 'cv_new_data_delete_request', 'cv_inbox_item_commented');
export const EmployerAdminNotificationSettings = literalArray('employer_dispute_started', 'employer_revenue_share_received', 'inbox_item_commented_by_platform_staff');
export const EmployerAdminUnderPeoNotificationSettings = literalArray('employer_under_peo_dispute_started', 'employer_under_peo_dispute_resolved', 'inbox_item_commented_by_platform_staff');
export const EmployerManagerNotificationSettings = literalArray('employer_dispute_started', 'inbox_item_commented_by_platform_staff');
export const EmployerManagerUnderPeoNotificationSettings = literalArray('employer_under_peo_dispute_started', 'inbox_item_commented_by_platform_staff');
export const PeoAdminWithBillingAdditionalNotificationSettings = literalArray('peo_revenue_share_received');
export const PeoAdminNotificationSettings = literalArray('peo_dispute_started', 'inbox_item_commented_by_platform_staff');
export const PeoManagerNotificationSettings = literalArray('peo_dispute_started', 'inbox_item_commented_by_platform_staff');
export const PeoAdminUnderPPNotificationSettings = literalArray(...PeoAdminNotificationSettings);
export const PeoManagerUnderPPNotificationSettings = literalArray(...PeoManagerNotificationSettings);
export const PeoPayrollProviderNotificationSettings = literalArray('pp_provider_revenue_share_received', 'pp_provider_data_dispute_started', 'pp_provider_employers_added_by_peo', 'pp_provider_feins_added_by_peo', 'pp_provider_locations_added_by_peo', 'inbox_item_commented_by_platform_staff');
export const VerifierStaffGovernmentNotificationSettings = literalArray('gov_verifier_request_sent', 'gov_verifier_report_generated', 'inbox_item_commented_by_platform_staff');
export const VerifierStaffCommercialNotificationSettings = literalArray('com_verifier_payment_declined', 'com_verifier_request_approved', 'com_verifier_request_declined', 'inbox_item_commented_by_platform_staff');
export const PeoPayrollProviderInvited = literalArray('peo_payroll_provider_invited');
export const ConsumerNotificationSettings = literalArray('employee_dispute_started', 'employee_declined_by_verifier', 'employee_responded_to_request', 'employee_report_generated', 'employee_report_reviewed', 'employee_my_verify_sent', 'employee_ask_for_approval', 'employee_sms_ask_for_approval', 'inbox_item_commented_by_platform_staff');
export const CvAdminNotificationSettingsLabels = {
    cv_employer_signed_up: {
        title: 'New Employer Signed Up',
        subtitle: 'Get an Email when a new Employer completes Sign Up process',
    },
    cv_employer_invited: {
        title: 'New Employer has been invited',
        subtitle: 'Get an Email when a new Employer is invited',
    },
    cv_verifier_invited: {
        title: 'New Verifier has been invited',
        subtitle: 'Get an Email when a new Verifier is invited',
    },
    cv_verifier_signed_up: {
        title: 'New Verifier Signed Up',
        subtitle: 'Get an Email when a new Verifier completes Sign Up process',
    },
    cv_employee_sent_my_verify: {
        title: 'Employee sent a verification proactively',
        subtitle: 'Get an Email when an Employee sends a Verification proactively using My Verify functionality',
    },
    cv_data_dispute_initiated: {
        title: 'Employee initiated a Data Dispute',
        subtitle: 'Get an Email when an Employee creates a Data Dispute with their Employer',
    },
    cv_report_created_status: {
        title: 'Verification Report has been generated',
        subtitle: 'Get an Email when a Verification Report is generated',
    },
    cv_payment_received: {
        title: 'Verifier Payment has been received',
        subtitle: 'Get an Email when a Verifier Payment is received',
    },
    cv_payment_declined: {
        title: 'Verifier Payment has been declined',
        subtitle: 'Get an Email when a Verifier Payment is declined',
    },
    cv_new_get_help_request: {
        title: 'New Get Help Request has been received',
        subtitle: 'Get an Email when a user submits a Get Help Request',
    },
    cv_new_data_delete_request: {
        title: 'New Employee Data Delete request has been received',
        subtitle: 'Get an Email when an Employee submits Data Delete Request',
    },
    cv_inbox_item_commented: {
        title: 'Inbox Item Commented',
        subtitle: 'Get an Email when a Verifier or an Employee leaves a new comment for an Inbox Item',
    },
};
export const PeoPayrollProviderInvitedLabels = {
    peo_payroll_provider_invited: {
        title: 'New Peo Payroll Provider user has been invited',
        subtitle: 'Get an Email when a new Peo Payroll Provider user is invited',
    },
};
export const CvManagerNotificationSettingsLabels = {
    cv_employer_signed_up: {
        title: 'New Employer Signed Up',
        subtitle: 'Get an Email when a new Employer completes Sign Up process',
    },
    cv_employer_invited: {
        title: 'New Employer has been invited',
        subtitle: 'Get an Email when a new Employer is invited',
    },
    cv_verifier_invited: {
        title: 'New Verifier has been invited',
        subtitle: 'Get an Email when a new Verifier is invited',
    },
    cv_verifier_signed_up: {
        title: 'New Verifier Signed Up',
        subtitle: 'Get an Email when a new Verifier completes Sign Up process',
    },
    cv_employee_sent_my_verify: {
        title: 'Employee sent a verification proactively',
        subtitle: 'Get an Email when an Employee sends a Verification proactively using My Verify functionality',
    },
    cv_data_dispute_initiated: {
        title: 'Employee initiated a Data Dispute',
        subtitle: 'Get an Email when an Employee creates a Data Dispute with their Employer',
    },
    cv_report_created_status: {
        title: 'Verification Report has been generated',
        subtitle: 'Get an Email when a Verification Report is generated',
    },
    cv_new_get_help_request: {
        title: 'New Get Help Request has been received',
        subtitle: 'Get an Email when a user submits a Get Help Request',
    },
    cv_new_data_delete_request: {
        title: 'New Employee Data Delete request has been received',
        subtitle: 'Get an Email when an Employee submits Data Delete Request',
    },
    cv_inbox_item_commented: {
        title: 'Inbox Item Commented',
        subtitle: 'Get an Email when a Verifier or an Employee leaves a new comment for an Inbox Item',
    },
};
const inboxItemCommentedByPlatformStaffLabel = {
    title: 'Inbox Item Internal Note',
    subtitle: 'Get an Email when Clear Verify leaves an internal note on an Inbox Item',
};
export const EmployerAdminNotificationSettingsLabels = {
    employer_dispute_started: {
        title: 'Data Dispute',
        subtitle: 'Get an Email when an Employee creates a Data Dispute you need to resolve',
    },
    employer_revenue_share_received: {
        title: 'Payment received',
        subtitle: 'Get an Email when you receive Revenue Share from Clear Verify',
    },
    inbox_item_commented_by_platform_staff: inboxItemCommentedByPlatformStaffLabel,
};
export const EmployerAdminUnderPeoNotificationSettingsLabels = {
    employer_under_peo_dispute_started: {
        title: 'Data Dispute',
        subtitle: 'Get an Email when an Employee creates a Data Dispute your PEO is to resolve',
    },
    employer_under_peo_dispute_resolved: {
        title: 'Data Dispute resolved',
        subtitle: 'Get an Email when your PEO has resolved a Data Dispute created by your employee',
    },
    inbox_item_commented_by_platform_staff: inboxItemCommentedByPlatformStaffLabel,
};
export const EmployerAdminWithoutBillingNotificationSettingsLabels = {
    employer_dispute_started: {
        title: 'Data Dispute',
        subtitle: 'Get an Email when an Employee creates a Data Dispute you need to resolve',
    },
    inbox_item_commented_by_platform_staff: inboxItemCommentedByPlatformStaffLabel,
};
export const EmployerManagerNotificationSettingsLabels = {
    employer_dispute_started: {
        title: 'Data Dispute',
        subtitle: 'Get an Email when an Employee creates a Data Dispute you need to resolve',
    },
    inbox_item_commented_by_platform_staff: inboxItemCommentedByPlatformStaffLabel,
};
export const EmployerManagerUnderPeoNotificationSettingsLabels = {
    employer_under_peo_dispute_started: {
        title: 'Data Dispute',
        subtitle: 'Get an Email when an Employee creates a Data Dispute your PEO is to resolve',
    },
    inbox_item_commented_by_platform_staff: inboxItemCommentedByPlatformStaffLabel,
};
export const PeoStaffWithBillingAdditionalNotificationSettingsLabels = {
    peo_revenue_share_received: {
        title: 'Payment Received',
        subtitle: 'Get an Email when you receive a payment',
    },
};
export const PeoAdminNotificationSettingsLabels = {
    peo_dispute_started: {
        title: 'Data Dispute',
        subtitle: 'Get an Email when an Employee creates a Data Dispute you need to resolve',
    },
    inbox_item_commented_by_platform_staff: inboxItemCommentedByPlatformStaffLabel,
};
export const PeoAdminUnderPPNotificationSettingsLabels = {
    ...PeoAdminNotificationSettingsLabels,
};
export const PeoManagerNotificationSettingsLabels = {
    peo_dispute_started: {
        title: 'Data Dispute',
        subtitle: 'Get an Email when an Employee creates a Data Dispute you need to resolve',
    },
    inbox_item_commented_by_platform_staff: inboxItemCommentedByPlatformStaffLabel,
};
export const PeoManagerUnderPPNotificationSettingsLabels = {
    ...PeoManagerNotificationSettingsLabels,
};
export const PeoPayrollProviderNotificationSettingsLabels = {
    pp_provider_data_dispute_started: {
        title: 'Data Dispute',
        subtitle: 'Get an Email when an Employee creates a Data Dispute you need to resolve',
    },
    pp_provider_employers_added_by_peo: {
        title: 'New Employers were added by PEO',
        subtitle: 'Get an Email when data from a new employer is added to the platform by a PEO',
    },
    pp_provider_feins_added_by_peo: {
        title: 'New FEIN was added by PEO',
        subtitle: 'Get an Email when a new FEIN is added to the platform by a PEO',
    },
    pp_provider_locations_added_by_peo: {
        title: 'New Location was added by PEO',
        subtitle: 'Get an Email when new Location is added to the platform by PEO under PEO Payroll Provider',
    },
    pp_provider_revenue_share_received: {
        title: 'Payment received',
        subtitle: 'Get an Email when you receive a payment',
    },
    inbox_item_commented_by_platform_staff: inboxItemCommentedByPlatformStaffLabel,
};
export const ConsumerNotificationSettingsLabels = {
    employee_sms_ask_for_approval: {
        title: 'New Verification Request (SMS)',
        subtitle: 'Get an SMS when a Verifier creates a Verification Request you need to approve or decline',
    },
    employee_ask_for_approval: {
        title: 'New Verification Request (Email)',
        subtitle: 'Get an Email when a Verifier creates a Verification Request you need to approve or decline',
    },
    employee_responded_to_request: {
        title: 'Verification Request Action Confirmation',
        subtitle: 'Get an Email when you either approve or decline a Verification Request',
    },
    employee_report_generated: {
        title: 'Verification Report Creation',
        subtitle: 'Get an Email when a Verification Report is created',
    },
    employee_report_reviewed: {
        title: 'Report Reviewed by Verifier',
        subtitle: 'Get an Email when a Verifier has reviewed a Verification Report',
    },
    employee_my_verify_sent: {
        title: 'My Verify Confirmation',
        subtitle: 'Get an Email when you have sent a Verification to a Verifier proactively',
    },
    employee_declined_by_verifier: {
        title: 'Verification Request Declined by Verifier',
        subtitle: 'Get an Email when a Verifier  declines a verification you initiated proactively (using the My Verify function)',
    },
    employee_dispute_started: {
        title: 'Data Dispute Confirmation',
        subtitle: 'Get an email when you initiate a Data Dispute with your Employer',
    },
    inbox_item_commented_by_platform_staff: inboxItemCommentedByPlatformStaffLabel,
};
export const VerifierStaffCommercialSettingsLabels = {
    com_verifier_request_sent: {
        title: 'Verification Request',
        subtitle: 'Get an Email when you send a Verification Request to an Employee',
    },
    com_verifier_request_approved: {
        title: 'Verification Request approved',
        subtitle: 'Get an Email when your Verification Request is approved by an Employee',
    },
    com_verifier_request_declined: {
        title: 'Verification Request declined',
        subtitle: 'Get an Email when your Verification Request is declined by an Employee',
    },
    com_verifier_report_generated: {
        title: 'Verification Report generated',
        subtitle: 'Get an Email when your Verification Report is generated',
    },
    com_verifier_payment_declined: {
        title: 'Payment declined',
        subtitle: 'Get an Email when a Payment is declined',
    },
    inbox_item_commented_by_platform_staff: inboxItemCommentedByPlatformStaffLabel,
};
export const VerifierStaffGovernmentSettingsLabels = {
    gov_verifier_request_sent: {
        title: 'Create Request Confirmation',
        subtitle: 'Get an Email when you send a Verification Request to an Employee',
    },
    gov_verifier_report_generated: {
        title: 'Verification Report generated',
        subtitle: 'Get an Email when your Verification Report is generated',
    },
    inbox_item_commented_by_platform_staff: inboxItemCommentedByPlatformStaffLabel,
};
export const SUPPORT_CLEARVERIFY_EMAIL = 'support@clearverify.com';
//# sourceMappingURL=notificationSettings.js.map